import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  subheading: createResponsiveStyles({
    base: {
      color: theme.colors.dark.base,
      fontFamily: "ProximaBold",
      marginTop: -theme.spacing.xsmall,
      textAlign: "center",
    },
    medium: {
      marginTop: theme.spacing.xsmall,
    },
  }),
  subheadingContainer: createResponsiveStyles({
    base: {
      flexDirection: "row",
      justifyContent: "center",
      textAlign: "center",
    },
  }),
  CTA: createResponsiveStyles({
    base: {
      flex: 1,
      justifyContent: "center",
    },
  }),
  CTAHeading: createResponsiveStyles({
    base: {
      textAlign: "center",
      color: theme.colors.brand.base,
      fontFamily: "ProximaBold",
      marginBottom: theme.spacing.small,
      marginTop: -theme.spacing.small,
      paddingHorizontal: 0,
      fontSize: theme.fontDefaults.large.fontSize,
    },
    medium: {
      fontSize: theme.fontDefaults.xlarge.fontSize,
    },
  }),
  button: {
    width: "100%",
    maxWidth: 200,
    margin: "auto",
    marginBottom: theme.spacing.small,
  },
  descriptionText: {
    textAlign: "center",
    marginBottom: theme.spacing.medium,
    marginTop: theme.spacing.small,
    height: theme.spacing.large,
  },
  mobileDescription: createResponsiveStyles({
    base: {
      textAlign: "center",
      marginTop: theme.spacing.xsmall,
      minHeight: theme.spacing.xlarge,
    },
    small: {
      marginTop: 0,
    },
  }),
  CTAImage: {
    width: "100%",
    height: "100%",
  },

  quantityWrap: {
    marginTop: "auto",
    paddingVertical: theme.spacing.xsmall,
  },

  selectTypePanel: {
    flexDirection: "row",
    alignItems: "center",
  },

  selectTypeHeading: createResponsiveStyles({
    base: {
      marginLeft: theme.spacing.small,
      flex: 1,
    },
    medium: {
      marginLeft: theme.spacing.large,
    },
  }),
  selectTypeImage: {
    width: 110,
    height: 110,
  },

  gridMarginTop: { marginTop: theme.spacing.large },

  description: createResponsiveStyles({
    base: {
      textAlign: "center",
      letterSpacing: -0.1,
      marginTop: "auto",
      fontSize: 12,
      lineHeight: 14,
    },
    small: {
      ...theme.fontDefaults.small,
    },
  }),
  descriptionDisclaimer: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.small,
      marginTop: "auto",
      ...theme.fontDefaults.xsmall2,
      textAlign: "center",
    },
    small: {
      ...theme.fontDefaults.xsmall,
    },
    medium: {
      marginBottom: 0,
    },
  }),
});
